import { render, staticRenderFns } from "./deleteChainSupplier.vue?vue&type=template&id=03e2d426"
import script from "./deleteChainSupplier.vue?vue&type=script&lang=js"
export * from "./deleteChainSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports